import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const CmsContentPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ContentPageContainer" */
      './CmsContentPageContainer.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
